import React, { useEffect, useState, useRef } from "react";

import styled from "styled-components";
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'
import OpenApp from '../../components/OpenApp';
import { fetchTalentTask } from './api'
import { connect } from 'react-redux';
import { jumpTo } from '@/utils'
import Desc from './componens/Desc/index'
import Award from './componens/award'
import h5Share from '@/utils/h5Share'
import cardBg from './img/cardBg.png'
import publish from './img/publish.png'
import publish2 from './img/publish2.png'
import btnBg2 from './img/btn2.png'
import { Toast } from "antd-mobile";
import  NewCard from './componens/newCard'
import  ShareCard from './componens/shareCard'

import { getObjectFormSerach } from '@/utils'

const Active_170 = ({token}) => {
  const active_id =  170;
  const [activityStatus, setActivityStatus] = useState(1);

  const [isJoinInActivity, setIsJoinInActivity] = useState(false); // 不能参加
  const [isRegisterDateIn30Days, setIsRegisterDateIn30Days] = useState(true);
  const isStorm = bwmodel.app === 'storm';
  // const shareUrl = `#/active_${active_id}`
  const { showAward } = getObjectFormSerach(window.location.search);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [taskInfo, setTaskInfo] = useState({});
  const newCardRef = useRef();
  const awardRef = useRef();
   const [redPacketStages, setRedPacketStages]  = useState([
    { id: 1, name: '7天', amount: '分688元', finished: false },
    { id: 2, name: '14天', amount: '分1688元', finished: false   },
    { id: 3, name: '21天', amount: '分3888元', finished: false   },
  ])

   const isLogin = !!token;
 
   useEffect(() => {
     if (!isLogin) {
      Toast.info('请先登录')
     }
 
     if(showAward === "1") {
      awardRef.current.show()
     }
    //  handleUploadTrace('identity_page-visitor', 'visitor')
   }, [])


  useEffect(() => {
    document.title = '风云社区新秀养成计划 ';
    h5Share.main({
      title: `风云社区新秀养成计划 `,
      desc: '你的第一条投资分析帖，我们买单！',
      link: process.env.REACT_APP_DEMAND_URL + 'active_'+ active_id,
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();

    // getData();

  }, [])

  useEffect(() => { 
    const params = {
      "activityId": active_id,
      "deviceNo": "xxxxx",
      "deviceToken": "xxxxx",
      "deviceType": "MOBILE",
      "mac": "xxxxxx",
      "operateSource": "H5",
      "refer": "wogoo.com",
      "userAgent": "a",
      imei: 'imeitest'
    }
   
    fetchTalentTask(params)
      .then(res => {
        
        if(res.isTwentyOneDaysTaskFinished ) {
          // setTwentyOneDaysTask(true)
          setProgressPercentage(100)
        } else if(res.isFourteenDaysTaskFinished) {
          // setFourteenDaysTask(true)
          setProgressPercentage(66)
        } else if(res.isSevenDaysTaskFinished ) {
          // setSevenDaysTask(true)
          setProgressPercentage(33)
        }

        setRedPacketStages([
          { id: 1, name: '7天', amount: `分${Number(res.awardRuleDTO.pool7).toFixed(0)}元`, finished: false },
          { id: 2, name: '14天', amount: `分${Number(res.awardRuleDTO.pool14).toFixed(0)}元`, finished: false   },
          { id: 3, name: '21天', amount: `分${Number(res.awardRuleDTO.pool21).toFixed(0)}元`, finished: false   },
        ])

        
        setTaskInfo(res)
        setActivityStatus(res.activityStatus)
        console.log(token);
          setIsRegisterDateIn30Days(res.isRegisterDateIn30Days)
        setIsJoinInActivity(res.isJoinInActivity)

        if(!res.isJoinInActivity && token) {
          newCardRef.current.show()
        }
       
      })
  }, [])

  const handleLeftClick = () => {

      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    // }
  }

  const linkToDownload = () => {
    // 埋点
    // handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }
  const handleLogin = () => {
   
     // 埋点
     if (!isStorm) {
      linkToDownload()
      return
    }
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  return (
    <div>
      {
        isStorm && <Header
          title={'风云社区新秀养成计划'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
           right={
              bwmodel.compareVersion('4.17.9') ?( <img
              onClick={()=> {
                bridge.callHandler('nativeEvent', {
                    event: 'shareLink',
                    params: {
                      // shareLinkParams:{
                      title: `风云社区新秀养成计划`,
                      desc: '你的第一条投资分析帖，我们买单！',
                      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_170',
                    }
                  })
              }}
              style={{width:'20px','vertical-align': 'middle'}}
              src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)}
              alt="分享"
            />
              )
          :''
            }
        />
      }

      <Container style={{marginTop: isStorm?'44px':'0px'}} className={`${(activityStatus === 1  && isRegisterDateIn30Days)? '':'expire1'}`}>
      <img className="member-img" src={require('./img/Slice1.png')} alt="市值风云" />
        <div className="card first_card">
            <div className="card-title">
              <img src={require(`./img/分享投资相关内容.png`)} alt="标题" />
              
            </div>
            <div className="desc">累计打卡21天完成每日任务，即可解锁所有奖励  </div>
            <div className="award-box">
              <div>
                <div className="title">累计打卡有奖</div>
                <div className="sub_title">累计打卡{taskInfo.continueSignCount || 0}天</div>
              </div>
              <div className="progress-box">
              <div className="progress-bar-container">
                <div className="progress-bar" style={{ width: `${progressPercentage}%` }}></div>
                {redPacketStages.map((stage, index) => (
                  <div 
                    key={stage.id} 
                    className={`stage-marker`}
                    style={{ left: `${((index / (redPacketStages.length - 1 )) *0.6 + 0.2) * 100}%` }}
                  >
                  <div className="amount">
                    {stage.amount}
                  </div>
                  <div>
                    {/* sevenDaysTask */}
                    {
                      (progressPercentage / 30 - 1) > index ?
                      <img src={require('./img/红包_2.png')} alt={stage.title} />: 
                      <img src={require('./img/红包_1.png')} alt={stage.title} />
                    }
                  
                  </div>
                  <div className="name">{stage.name}</div>
                </div>
          ))}
        </div>
              </div>
            </div>
            <div className="tips">注：发帖需符合社区规则，需>=30字，且获得1条评论+1个点赞的具有个股/指数/板块关联的帖子/文章；</div>
        </div>
        {/* <Award /> */}
        <div className="card">
            <div className="card-title">
              <img src={require(`./img/活动任务要求.png`)} alt="标题" />
            </div>
        <div className="box-item">
          <div className="badge">每日任务 1</div>
          <div>
            <div className="title">发布原创投资相关内容3篇</div>
            <div className="sub">且>=30字以上({taskInfo.publishTask? taskInfo.publishTask.taskCount:0 }/3)</div>
          </div>
          <div className={`btn ${(isJoinInActivity || !token || (taskInfo.publishTask && taskInfo.publishTask.taskFinish))?'':'btn2'}`}
            onClick={()=> {
              if(!isJoinInActivity) return Toast.info('本活动仅限新用户参加')
              if(taskInfo.publishTask && taskInfo.publishTask.taskFinish) return Toast.info('该任务已完成')
              jumpTo(`storm://app/sns`)
            }}
          >
     
            {(!isJoinInActivity && token)? '无法参加': (taskInfo.publishTask && taskInfo.publishTask.taskFinish) ? '已完成': '去完成'}
          </div>
        </div>
        <div className="box-item">
          <div className="badge">每日任务 2</div>
          <div>
            <div className="title">去点赞他人内容5篇</div>
            <div className="sub">({taskInfo.likeTask? taskInfo.likeTask.taskCount: 0 }/5)</div>
          </div>
          <div className={`btn ${(isJoinInActivity || !token || (taskInfo.likeTask && taskInfo.likeTask.taskFinish))?'':'btn2'}`}
            onClick={()=> {
              if(!isJoinInActivity) return Toast.info('本活动仅限新用户参加')
              if(taskInfo.likeTask && taskInfo.likeTask.taskFinish) return Toast.info('该任务已完成')
              jumpTo(`storm://app/sns`)
            }}
          >
            {(!isJoinInActivity && token)? '无法参加': (taskInfo.likeTask && taskInfo.likeTask.taskFinish)? '已完成': '去完成'}
          </div>
        </div>
        <div className="box-item">
          <div className="badge">每日任务 3</div>
          <div>
            <div className="title">发10字以上评论5条</div>
            <div className="sub">({taskInfo.commentTask? taskInfo.commentTask.taskCount: 0 }/5)</div>
          </div>
          <div className={`btn ${(isJoinInActivity || !token || (taskInfo.commentTask && taskInfo.commentTask.taskFinish))?'':'btn2'}`}
            onClick={()=> {
              if(!isJoinInActivity) return Toast.info('本活动仅限新用户参加')
              if(taskInfo.commentTask && taskInfo.commentTask.taskFinish) return Toast.info('该任务已完成')
              jumpTo(`storm://app/sns`)
            }}
          >
            {(!isJoinInActivity && token)? '无法参加': (taskInfo.commentTask && taskInfo.commentTask.taskFinish) ? '已完成': '去完成'}
          </div>
        </div>
        
      
        <div className="box-item last_item">
          <div className="badge">惊喜任务</div>
          <div>
            <div className="title">30天内完成涨粉100个</div> 
            <div className="sub">( {taskInfo.fansTask? taskInfo.fansTask.taskCount: 0 }/100)额外必得18元！</div>
          </div>
          <div className={`btn ${(isJoinInActivity || !token || (taskInfo.fansTask && taskInfo.fansTask.taskFinish ))?'':'btn2'}`}
            onClick={()=> {
              if(!isJoinInActivity) return Toast.info('本活动仅限新用户参加')
              if(taskInfo.fansTask && taskInfo.fansTask.taskFinish ) return Toast.info('该任务已完成')
              jumpTo(`storm://app/sns`)
            }}
          >
            {(!isJoinInActivity && token)? '无法参加': (taskInfo.fansTask && taskInfo.fansTask.taskFinish) ? '已完成': '去完成'}
          </div>
        </div>
        </div>
        <div className={`submit ${(isJoinInActivity || !token)?'': 'disabled'}`} 
          onClick={()=> {
            if(!isJoinInActivity) return Toast.info('本活动仅限新用户参加')
          
            if(!token) {
              return  handleLogin()
            } 
            
            // const text = content ? `#${content}#`:''
            bridge.callHandler('nativeEvent', {
              event: 'openPublishForumEvent',
              params: {
                text: '#风云新秀养成计划#', 
                // imageBase64: str
              }
            }, res => {})
            
            // jumpTo(`storm://app/sns`)
          }}
        ></div>
   
        <div className="card ">
          <div className="card-title">
            <img src={require(`./img/全民创作者计划.png`)} alt="标题" />
          </div>
          <div className="desc">冲榜做版主，互动发贴最高可得3000元。</div>
          <div className="tips">注：发帖需符合社区规则，有1条评论/1个点赞，才可加入冲榜评比；</div>
           <div className="button" 
           onClick={()=> {
             jumpTo(`/active_130`);
           }}
           > </div>
        </div>
   

        {/* 活动规则 */}
        <Desc />
        <Award ref={awardRef} login={handleLogin} token={token}/>
        <NewCard ref={newCardRef} />
        <ShareCard />
        
      </Container>
        {
          !isStorm && <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_170`}></OpenApp>
        }
    </div>
  )
}


const Container = styled.div`
  background: #B52B23;
  padding:0 15px 66px;
  &.expire {
    filter: grayscale(100%);
  }
  img {
    vertical-align: middle;
    font-size:0;
    max-width:100%;
    // width: 100%;
  }
  .member-img {
    margin: 0 -15px;
    width: calc(100% + 30px);
    max-width: fit-content;
  }
  .submit {
    width: 240px;
    height: 60px;
    background-image: url(${publish2});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 20px auto;
    &.disabled {
      background-image: url(${publish});
    }
  }
  .card {
    border: 2px solid  rgba(255, 255, 255, 1);
    border-radius: 13px;
    background-color: #fff;
    background-image: url(${cardBg});
    background-repeat: no-repeat;
    background-size: 100% 44px;
    padding-bottom: 15px;
   
    &.first_card {
      position: relative;
      z-index: 1;
      margin-top: -40px;
    }
    + .card {
      margin-top: 19px;
    }
    .card-title {
      height: 27px;
      margin-top: 10px;
      margin-left: 22px;
      img{
        height: 100%;
        width: auto;
      }
    }
    .desc { 
      padding: 10px 22px 15px;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      color:#111111;
    }
    .tips {
      padding: 0 22px;
      font-weight: 500;
      font-size: 13px;
      color: #DA3B32;
      line-height: 20px;
    }
  }
  .award-box {
    // width: 644rpx;
    margin: 0 11px;
    height: 95px;
    background: rgba(255,203,110,0.25);
    border-radius: 12px;
  }
  .button {
    width: 120px;
    height: 36px;
    background-image: url(${btnBg2});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-left: 20px;
    margin-top: 10px;
  }
  .box-item {
    border-radius: 14px;
    border: 1px solid #FFD487;
    background: #FFFFFF;
    position: relative;
    margin: 0 11px;
    margin-top: 10px;
    padding: 28px 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
     &.last_item {
    
       background: rgba(255,203,110,0.4);
      .badge { 
        // background: #FFD487;
        background: linear-gradient( 171deg, #FFA827 1%, #FF3D36 27%, #FFCE95 82%);
        color: #FFFFFF;
      }
    }
    .badge { 
      position: absolute;
      z-index: 1;
      top: 0px;
      left: 0px;
      width: 64px;
      height: 18px;
      background: #FFD487;
      border-radius: 12px 0px 6px 0px;
      font-size: 10px;
      text-align: center;
      line-height: 18px;
      color: #745318;
    }
    .title { 
      font-weight: 500;
      font-size: 15px;
      color: #111111;
      line-height: 20px;
    }
    .sub {
      font-weight: 400;
      font-size: 12px;
      color: #FF0000;
      line-height: 16px;
    }
    .btn {
      width: 80px;
      height: 26px;
      background: linear-gradient( 171deg, #FFA827 1%, #FF3D36 27%, #FFCE95 82%);
      border-radius: 13px;
      text-align: center;
      font-weight: 600;
      font-size: 13px;
      line-height: 26px;
      color: #FFFFFF;
      &.btn2 {
        background: #C2C2C2;
      }
    }
    + .box-item {
     
    }
  }
    

.fixed_box {
  position: fixed;
  bottom: 120px;
  width: 48px;
  right: 10px;
}
.award-box { 
  display: flex;
  align-items: center;
  padding:0 10px;
  .title {
    font-size: 15px;
    color: #111111;
    line-height: 21px;
  }
  .sub_title {
    font-size: 13px;
    color: #6F7073;
    line-height: 18px;
  }
}
.progress-box {
 width: 200px;
  flex: 1;
  margin-left: 20px;
}
.progress-bar-container {
  position: relative;
  height: 12px;
  background-color: #c4c4c4;
  border-radius: 6px;
  margin: 2rem 0;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(to right, #FF9900, #FF9900);
  border-radius: 6px;
  transition: width 0.5s ease;
}
.stage-marker {
  position: absolute;
  top: -4px;
  width: 44px;
  height: 24px;
  border-radius: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  transition: all 0.3s ease;
  .amount {
    width: 55px;
    height: 17px;
    font-size: 9px;
    line-height: 17px;
    color: #fff;
    text-align: center;
    background: linear-gradient( 171deg, #FFA827 1%, #FF3D36 27%, #FFCE95 82%);
    border-radius: 9px;
  }
  img {
    width: 25px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .name {
    color: #111;
  }
  .text {
    
  }
}
}
`


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_170))




// WEBPACK FOOTER //
// ./src/views/activity_170/index.js